import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from './utils';
import { config } from '../config';
import { DevDeviceWhitelist } from '../features/app/context/dev-device-whitelist/components/DevDeviceWhitelistList';

const REQUEST_MAPPING = '/dev-device-whitelist';
const TAG = 'DevDeviceWhitelist';

export const devDeviceWhitelistApi = createApi({
    reducerPath: 'devDeviceWhitelist',
    tagTypes: [TAG],
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.DEVICE_STATE_SERVICE,
        prepareHeaders,
    }),
    endpoints: (builder) => ({
        getAllWhitelistedDevDevices: builder.query<DevDeviceWhitelist[], void>({
            query: () => REQUEST_MAPPING,
            providesTags: [TAG],
        }),
        whitelistDevDevice: builder.mutation<DevDeviceWhitelist, DevDeviceWhitelist[]>({
            query: (body) => ({
                url: REQUEST_MAPPING,
                method: 'POST',
                body,
            }),
            invalidatesTags: [TAG],
        }),
    }),
});

export const {
    useGetAllWhitelistedDevDevicesQuery,
    useWhitelistDevDeviceMutation,
} = devDeviceWhitelistApi;
